import { A9Service, AbstractDataProviderV2, IDataProviderV2, IResourceParams } from 'components/system';
import { CustomerSubTypeAdd, CustomerSubTypeUpdate, RsCustomerSubType, RsCustomerSubTypeInfo } from './types';
import { RsEmpty } from 'common/index/services/types';

export interface ICustomerSubTypeDataProvider
    extends IDataProviderV2<RsCustomerSubType, RsCustomerSubTypeInfo, CustomerSubTypeAdd, CustomerSubTypeUpdate> {
    archive(resourceParams: IResourceParams): Promise<RsCustomerSubTypeInfo>;
    unarchive(resourceParams: IResourceParams): Promise<RsCustomerSubTypeInfo>;
    patchBirthdayNotify(data: { customerSubTypeIds: number[] }): Promise<RsEmpty>;
}

@A9Service('customerSubTypeDataProvider')
class CustomerSubTypeDataProvider
    extends AbstractDataProviderV2<RsCustomerSubType, RsCustomerSubTypeInfo, CustomerSubTypeAdd, CustomerSubTypeUpdate>
    implements ICustomerSubTypeDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/sub-types');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public archive(resourceParams: IResourceParams = {}): Promise<RsCustomerSubTypeInfo> {
        return this.customPatch({ active: false }, resourceParams);
    }

    public unarchive(resourceParams: IResourceParams = {}): Promise<RsCustomerSubTypeInfo> {
        return this.customPatch({ active: true }, resourceParams);
    }

    public patchBirthdayNotify(data: { customerSubTypeIds: number[] }): Promise<RsEmpty> {
        const url = `${this.url}/birthday-notify`;
        return this.service.updateRequest<RsEmpty>(url, this.patchMethod, data);
    }
}
